// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var Link = require("next/link").default;
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
var SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
var IsNewQueryParam = require("./IsNewQueryParam.bs.js");
var React = require("@headlessui/react");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MarketingProfileMembersListRemoveMutation_graphql = require("../../__generated__/MarketingProfileMembersListRemoveMutation_graphql.bs.js");
var MarketingProfileMembersList_teamMarketingProfile_graphql = require("../../__generated__/MarketingProfileMembersList_teamMarketingProfile_graphql.bs.js");
var MarketingProfileMembersList_member_marketingProfileMember_graphql = require("../../__generated__/MarketingProfileMembersList_member_marketingProfileMember_graphql.bs.js");
var MarketingProfileMembersList_member_menu_marketingProfileMember_graphql = require("../../__generated__/MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.bs.js");

var convertVariables = MarketingProfileMembersListRemoveMutation_graphql.Internal.convertVariables;

var convertResponse = MarketingProfileMembersListRemoveMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = MarketingProfileMembersListRemoveMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MarketingProfileMembersListRemoveMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, MarketingProfileMembersListRemoveMutation_graphql.node, convertResponse, convertWrapRawResponse);

var RemoveMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

var convertFragment = MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMembersList_member_menu_marketingProfileMember_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MarketingProfileMembersList$Member$Menu$MenuItem(props) {
  var __disabled = props.disabled;
  var disabled = __disabled !== undefined ? __disabled : false;
  return JsxRuntime.jsx(React.Menu.Item, {
              disabled: disabled,
              className: "ui-active:bg-zinc-50 block px-3 py-2 leading-6 rounded",
              children: props.children
            });
}

var MenuItem = {
  make: MarketingProfileMembersList$Member$Menu$MenuItem
};

function MarketingProfileMembersList$Member$Menu(props) {
  var connectionId = props.connectionId;
  var member = use$1(props.member);
  var match = use();
  var removeMemberMutate = match[0];
  var match$1 = SystemMessages.useSystemMessages();
  var addMessage = match$1.addMessage;
  var addRemoveMemberErrorMessage = function () {
    addMessage(SystemMessages.Message.make(undefined, "error", "There was a problem removing the team member. Please try again.", 5000, undefined, undefined));
  };
  var addMemberNotFoundMessage = function () {
    addMessage(SystemMessages.Message.make(undefined, "warning", "Looks like this team member has already been removed. Please refresh the page.", 5000, undefined, undefined));
  };
  var onRemove = function () {
    removeMemberMutate({
          connectionId: connectionId,
          input: {
            memberId: member.id
          }
        }, undefined, undefined, undefined, (function (response, errors) {
            var match = response.removeMarketingProfileMember;
            if (errors !== undefined) {
              return addRemoveMemberErrorMessage();
            }
            if (match === undefined) {
              return addRemoveMemberErrorMessage();
            }
            switch (match.__typename) {
              case "MarketingProfileMemberRemoved" :
                  return ;
              case "NotFoundError" :
                  return addMemberNotFoundMessage();
              case "__unselected" :
                  return addRemoveMemberErrorMessage();
              
            }
          }), (function (_error) {
            addRemoveMemberErrorMessage();
          }), undefined);
  };
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  var match$2 = IsNewQueryParam.use();
  var match$3 = member.publicUrl;
  var tmp;
  var exit = 0;
  if (match$3 !== undefined) {
    if (hasFullProfile) {
      tmp = JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu$MenuItem, {
            children: JsxRuntime.jsxs("a", {
                  children: [
                    "View member profile",
                    JsxRuntime.jsx("span", {
                          children: ", " + member.displayName,
                          className: "sr-only"
                        })
                  ],
                  className: "text-zinc-900 hover:text-zinc-900 cursor-pointer",
                  href: Scalars.$$URL.toString(Caml_option.valFromOption(match$3)),
                  target: "_blank"
                })
          });
    } else {
      exit = 1;
    }
  } else if (hasFullProfile) {
    tmp = null;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu$MenuItem, {
          children: JsxRuntime.jsx("span", {
                children: "View member profile (Pro plan only)",
                className: "text-zinc-400 cursor-default"
              }),
          disabled: true
        });
  }
  return JsxRuntime.jsxs(React.Menu, {
              as: "div",
              className: "relative flex-none",
              children: [
                JsxRuntime.jsxs(React.Menu.Button, {
                      className: "-m-2.5 block p-2.5 text-zinc-500 hover:text-zinc-900 focus-visible:ring",
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "Open options",
                              className: "sr-only"
                            }),
                        JsxRuntime.jsx(IconV5.make, {
                              icon: "three-dots",
                              className: "h-4 w-4"
                            })
                      ]
                    }),
                JsxRuntime.jsxs(React.Menu.Items, {
                      className: "absolute right-0 z-10 mt-2 w-52 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-zinc-900/5 focus:outline-none py-3 px-2",
                      children: [
                        tmp,
                        JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu$MenuItem, {
                              children: JsxRuntime.jsxs(Link, {
                                    href: "/account/team_marketing_profile/members/" + member.id + "/edit?is_new=" + (
                                      match$2[0] ? "1" : "0"
                                    ),
                                    className: "text-zinc-900 hover:text-zinc-900",
                                    children: [
                                      "Edit",
                                      JsxRuntime.jsx("span", {
                                            children: ", " + member.displayName,
                                            className: "sr-only"
                                          })
                                    ]
                                  })
                            }),
                        JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu$MenuItem, {
                              children: JsxRuntime.jsxs("button", {
                                    children: [
                                      "Remove",
                                      JsxRuntime.jsx("span", {
                                            children: ", " + member.displayName,
                                            className: "sr-only"
                                          })
                                    ],
                                    className: "text-zinc-900 w-full flex",
                                    onClick: (function (param) {
                                        onRemove();
                                      })
                                  })
                            })
                      ]
                    })
              ]
            });
}

var Menu = {
  RemoveMutation: RemoveMutation,
  Fragment: Fragment,
  Menu: undefined,
  MenuItem: MenuItem,
  make: MarketingProfileMembersList$Member$Menu
};

var convertFragment$1 = MarketingProfileMembersList_member_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMembersList_member_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMembersList_member_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MarketingProfileMembersList_member_marketingProfileMember_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMembersList_member_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

var Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MarketingProfileMembersList$Member(props) {
  var member = use$2(props.member);
  var match = member.profilePicture;
  return JsxRuntime.jsxs("li", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("img", {
                              className: "h-12 w-12 flex-none rounded-full bg-zinc-50",
                              alt: member.displayName + " profile picture",
                              src: match !== undefined ? match.url : AvatarSrcUrl.place_holder
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: member.displayName,
                                      className: "font-semibold leading-6 text-zinc-800"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("p", {
                                            children: member.title,
                                            className: "leading-6 text-zinc-900"
                                          }),
                                      className: "flex sm:hidden md:flex lg:hidden"
                                    })
                              ],
                              className: "min-w-0 flex-auto"
                            })
                      ],
                      className: "flex gap-x-4 items-center"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("p", {
                                    children: member.title,
                                    className: "leading-6 text-zinc-900"
                                  }),
                              className: "hidden sm:flex md:hidden lg:flex"
                            }),
                        JsxRuntime.jsx(MarketingProfileMembersList$Member$Menu, {
                              member: member.fragmentRefs,
                              connectionId: props.connectionId
                            })
                      ],
                      className: "flex items-center justify-between gap-x-6 \n            sm:w-1/2 sm:flex-none \n            md:w-auto md:flex \n            lg:w-1/2 lg:flex-none\n            "
                    })
              ],
              className: "flex justify-between gap-x-6 py-5"
            }, member.displayName);
}

var Member = {
  Menu: Menu,
  Fragment: Fragment$1,
  make: MarketingProfileMembersList$Member
};

var convertFragment$2 = MarketingProfileMembersList_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMembersList_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMembersList_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MarketingProfileMembersList_teamMarketingProfile_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMembersList_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

var Fragment_getConnectionNodes = MarketingProfileMembersList_teamMarketingProfile_graphql.Utils.getConnectionNodes;

var Fragment$2 = {
  getConnectionNodes: Fragment_getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MarketingProfileMembersList(props) {
  var marketingProfile = use$3(props.marketingProfile);
  var members = Core__Array.filterMap(marketingProfile.members.edges, (function (x) {
          return x;
        }));
  return JsxRuntime.jsx("ul", {
              children: members.map(function (param) {
                    var member = param.node;
                    return JsxRuntime.jsx(MarketingProfileMembersList$Member, {
                                member: member.fragmentRefs,
                                connectionId: marketingProfile.members.__id
                              }, member.id);
                  }),
              className: "divide-y divide-zinc-99",
              role: "list"
            });
}

var make = MarketingProfileMembersList;

exports.Member = Member;
exports.Fragment = Fragment$2;
exports.make = make;
/* commitMutation Not a pure module */
